import { setElementVisible } from '../../../../shared/DOM/setElementVisible.js';
import { getInputPass, getInputUser, getIntroAlertLogin } from '../getLoginView.js';

/**
 * Partial view del login: Acceso por OTP
 *
 * @returns Otp Access View json
 */
export function getOtpAccessView(isOtpStep) {
  const formProperties = [
    {
      name: 'otpAlert',
      type: 'alert',
      metadata: {
        closable: false,
        style: 'danger',
      },
      cols: 8,
    },
    {
      model: 'code',
      name: 'inputCode',
      // Los textos son más aclaratorios al revés
      title: edicom.locale.translate('login.otpcode_placeholder'),
      type: 'string',
      required: true,
      placeholder: edicom.locale.translate('login.otpcode'),
      metadata: {
        icon: 'lock',
        // minlength: No podemos limitarlo a 6 por el código de recuperación
        maxlength: 6,
      },
      pattern: '/^\\d{1,6}$/',
      cols: 8,
    },
    {
      name: 'btnOtpAccess',
      type: 'button',
      title: edicom.locale.translate('login.otpcode_confirm'),
      metadata: {
        icon: 'arrow-right',
        style: 'primary fill',
      },
      cols: 8,
    },
  ];

  // 12/2023 NUEVO: Solución remember user + pass > form que gestionamos en el onRegisterSession
  if (!isOtpStep) {
    formProperties.splice(1, 0, getInputUser(), getInputPass());
  }

  return {
    properties: [
      {
        type: 'object',
        name: 'otpAccess.html',
        cols: 4,
        properties: formProperties,
      },
      getIntroAlertLogin(document.querySelector('html')),
    ],
  };
}

export function getOtpAccessViewAlert() {
  return document.querySelector('ewc-alert[view-name="otpAlert"]');
}

export function getOtpAccessBtnSubmit() {
  return document.querySelector('ewc-button[view-name="btnOtpAccess"]');
}

export function hideOtpAccessError() {
  const eAlert = getOtpAccessViewAlert();
  setElementVisible(eAlert, false);
}

export function showOtpAccessError(message, params) {
  const eAlert = getOtpAccessViewAlert();
  setElementVisible(eAlert, true);
  eAlert.innerHTML = edicom.locale.translate(message, params);
}

export function hideOtpFields(isOtpStep) {
  hideOtpAccessError();

  if (!isOtpStep) {
    let input = document.querySelector('ewc-string[view-name="inputUser"]');
    input && setElementVisible(input, false);
    input = document.querySelector('ewc-password[view-name="inputPass"]');
    input && setElementVisible(input, false);

    focusInputCode();
  }
}

export function focusInputCode() {
  document.querySelector('ewc-string[view-name="inputCode"]')?.focus();
}
